import { User } from '../types/models/User'
export const userFioToString = (user: User, full?: boolean) => {
  const surname = user.surname
  const first_name = user.first_name
    ? full
      ? user.first_name
      : user.first_name[0] + '.'
    : ''
  const last_name = user.last_name
    ? full
      ? user.last_name
      : user.last_name[0] + '.'
    : ''

  if (!surname && !first_name && !last_name) {
    return user.username || 'неизвестный'
  }
  const result = [surname, first_name, last_name].join(' ')
  return result
}
